export default __webpack_public_path__ + "static/media/Group 12173.f7711623.png";